import styled from 'styled-components';

import FieldsSection from '../../../components/FieldsSection';

export const Root = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    padding: 0 60px;
    margin-bottom: 20px;
`;

export const MailingAddress = styled(FieldsSection.Field)`
    grid-column: 1 / 2;
    grid-row: 1 / 3;
`;
